import React from 'react';
import PropTypes from 'prop-types';
import Divider from 'widgets/Divider';
import Button from 'widgets/Button';
import colors from 'assets/styles/jsVariables/colors';
import Icon from '../Icon';
import './PageTitle.scss';

const styles = {
  buttonStyle: {
    '&:hover': {
      background: 'initial',
    }
  },
  buttonLabel: {
    fontFamily: 'museosansrounded_500',
    color: colors.darkGrey,
    textTransform: 'none',
    fontSize: '22px'
  }
};

function PageTitle({
  title,
  offset,
  rightIcon,
  upperCase,
  backLink,
  labelStyle,
  innerDivStyle,
  dividerStyle,
  showDivider,
  ...otherProps
}) {
  return (
    <div {...otherProps}>
      <div className="clearfix">
        <Button
          disabled={!backLink}
          cssStyles={{
            root: styles.buttonStyle,
            label: styles.buttonLabel
          }}
          onClick={() => backLink && window.appHistory.push(backLink)}
          style={{
            marginTop: 26,
            marginLeft: -16,
            ...innerDivStyle
          }}
        >
          <span style={{ ...labelStyle }}>
            {backLink && <Icon name="chevron-left" style={{ height: 14, width: 14 }} />}
            {upperCase ? title.toUpperCase() : title}
          </span>
        </Button>
        {
          rightIcon &&
          <div className="PageTitle__RightIcon">
            {rightIcon}
          </div>
        }
      </div>
      {
        title && showDivider &&
        <Divider
          style={{
            backgroundColor: colors.lightestGrey,
            marginLeft: -offset,
            marginRight: -offset,
            marginBottom: 20,
            height: '2px',
            ...dividerStyle
          }}
        />
      }
    </div>
  );
}
PageTitle.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  offset: PropTypes.number,
  style: PropTypes.object,
  rightIcon: PropTypes.array,
  backLink: PropTypes.string,
  upperCase: PropTypes.bool,
  labelStyle: PropTypes.object,
  innerDivStyle: PropTypes.object,
  dividerStyle: PropTypes.object,
  showDivider: PropTypes.bool,
};

PageTitle.defaultProps = {
  offset: 0,
  style: null,
  rightIcon: [],
  backLink: null,
  upperCase: true,
  labelStyle: null,
  innerDivStyle: null,
  dividerStyle: {},
  title: '',
  showDivider: true
};

export default PageTitle;



// WEBPACK FOOTER //
// ./src/components/PageTitle/PageTitle.jsx